import React from "react";

const SendIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M15 7.99327C15.0005 8.17144 14.9533 8.34649 14.8634 8.50033C14.7735 8.65416 14.6442 8.78119 14.4888 8.86827L3.99375 14.8689C3.84315 14.9543 3.67312 14.9995 3.5 15.0001C3.3405 14.9993 3.18351 14.9603 3.04215 14.8864C2.90078 14.8125 2.77915 14.7059 2.68739 14.5754C2.59564 14.4449 2.53643 14.2944 2.5147 14.1364C2.49297 13.9783 2.50936 13.8174 2.5625 13.667L4.25 8.67014C4.26649 8.62129 4.29769 8.57873 4.33931 8.5483C4.38093 8.51786 4.43095 8.50104 4.4825 8.50014H9C9.06855 8.50029 9.13639 8.48635 9.19932 8.45918C9.26224 8.432 9.31891 8.39218 9.3658 8.34219C9.41269 8.29219 9.4488 8.23309 9.47189 8.16855C9.49497 8.10401 9.50454 8.03541 9.5 7.96702C9.48867 7.83845 9.42917 7.7189 9.33345 7.63233C9.23772 7.54575 9.11281 7.49854 8.98375 7.50014H4.48375C4.43145 7.50015 4.38046 7.48375 4.33797 7.45325C4.29547 7.42275 4.26361 7.3797 4.24688 7.33014L2.55938 2.33389C2.49221 2.14239 2.4849 1.93498 2.53842 1.73922C2.59194 1.54346 2.70375 1.36862 2.859 1.23792C3.01425 1.10723 3.20559 1.02686 3.40761 1.00749C3.60962 0.98813 3.81275 1.03069 3.99 1.12952L14.49 7.12264C14.6446 7.20952 14.7732 7.33593 14.8629 7.48892C14.9525 7.6419 14.9998 7.81597 15 7.99327Z"
      fill="white"
    />
  </svg>
);

export default SendIcon;
